import { render, staticRenderFns } from "./sustainabilityDropdown.vue?vue&type=template&id=e020866c&scoped=true"
import script from "./sustainabilityDropdown.vue?vue&type=script&lang=js"
export * from "./sustainabilityDropdown.vue?vue&type=script&lang=js"
import style0 from "./sustainabilityDropdown.vue?vue&type=style&index=0&id=e020866c&prod&lang=scss&scoped=true"
import style1 from "./sustainabilityDropdown.vue?vue&type=style&index=1&id=e020866c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e020866c",
  null
  
)

export default component.exports
import QSelect from 'quasar/src/components/select/QSelect.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QField from 'quasar/src/components/field/QField.js';import Ripple from 'quasar/src/directives/Ripple.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QSelect,QItem,QItemSection,QItemLabel,QField});qInstall(component, 'directives', {Ripple});
